import { request } from '../../shared/api/http.js';

/**
 * What the service is holding: rows per sourcetype, the change log's span, storage and process figures.
 *
 * Not scoped to the time picker. These are properties of the deployment rather than of a range - "how
 * much is stored" has no last-24-hours answer - and a storage figure that comes back null means the
 * database is not a local file and the process genuinely cannot see it, which is stated rather than
 * estimated.
 */
export function systemMetrics(signal)
{
   return request('/api/v1/system', { signal });
}

/**
 * Who this credential is, and whether it may administer the service.
 *
 * The one thing a browser cannot work out for itself: a bearer token is opaque, and Identity's
 * `manage/info` reports an address and no roles. Both bundles read it - the end-user application to
 * decide whether to offer the administration portal at all, and the administration application to say
 * which credential is signed in.
 *
 * **It decides nothing.** Every administrative endpoint asks for the role itself; this only spares a UI
 * from drawing a door it already knows is locked.
 */
export function whoAmI(signal)
{
   return request('/api/v1/system/me', { signal });
}
